module.exports = __webpack_public_path__ + "static/media/room-2.e21bd9af.jpg";